export default function filterObject(data, lang) {
  const prefix = `_${lang}`;
  return Object.keys(data).reduce((acc, key) => {
    if (key.includes(prefix)) {
      acc[key.slice(0, -prefix.length)] = data[key];
    } else {
      acc[key] = data[key];
    }
    return acc;
  }, {});
}
